import {
  GroupContainer,
  TagsFilterGroupName,
} from "@/components/layout/CategoryContainer";
import { useTags } from "@/features/modals/TagsModal/tags";
import {
  getTagGroupName,
  groupObjectsByType,
} from "@/features/modals/TagsModal/utils";
import { t } from "@repo/translation";
import { FilterCheckbox, useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const TagsFilter = ({ actions, filters }: FilterItemsProps) => {
  const { data: tags } = useTags();
  const { market } = useSettings();
  const groups = groupObjectsByType(tags);

  return (
    <>
      {Object.keys(groups).map((type) => (
        <GroupContainer key={type}>
          <TagsFilterGroupName key={type}>
            {getTagGroupName(type, groups, market)}
          </TagsFilterGroupName>
          <FilterListContainer id="tags-filter">
            {groups[type].map((item: any) => (
              <FilterCheckbox
                key={item.name}
                id={item.name}
                value={item.name}
                label={item.translationKey ? t(item.translationKey) : item.name}
                checked={isChecked(filters.tags, item.name)}
                onCheckFilter={actions.setTags}
              />
            ))}
          </FilterListContainer>
        </GroupContainer>
      ))}
    </>
  );
};
